// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "form-3ArrZ";
var _3 = "form__wrapper-3qAZ1";
var _4 = "searchForm-1hT_m";
export { _1 as "__esModule", _2 as "form", _3 as "form__wrapper", _4 as "searchForm" }
export default { "__esModule": _1, "form": _2, "form__wrapper": _3, "searchForm": _4 }
